export default "__VITE_PUBLIC_ASSET__d69065b1__"